<template>
  <div class="navbar">
    <div class="header">
      <div>
        <router-link to="/"><img class="header-logo" src="images/logo.png" alt="" /></router-link>
      </div>

      <div class="routes">
        <ul>
          <!-- <li v-for="route in routes">
              <router-link :to="route.path" >{{ route.name }}</router-link>
            </li> -->
          <li><router-link to="/">{{ $t('route1') }}</router-link></li>
          <li><router-link to="/services">{{ $t('route2') }}</router-link></li>
          <li><router-link to="/references">{{ $t('route3') }}</router-link></li>
          <li><router-link to="/fences">{{ $t('route5') }}</router-link></li>
          <li><router-link to="/contact">{{ $t('route4') }}</router-link></li>
        </ul>

        <!-- Language Switcher -->
        <div class="langs">
          <img ref="husideRef" class="lang" src="images/hun.png" alt="HU"
            @click="$i18n.locale = 'hu', changeLang('hu')" />
          <img ref="ensideRef" class="lang" src="images/eng.jpg" alt="EN"
            @click="$i18n.locale = 'en', changeLang('en')" />
        </div>


      </div>
      <!-- Sidebar-->
      <div class="sidebar">
        <SideBar></SideBar>
      </div>
    </div>
  </div>
</template>

<script setup>
import SideBar from '../components/SideBar.vue';
import { ref, watchEffect, nextTick, onMounted } from "vue";

const props = defineProps({
  onHomePage: {
    type: Boolean,
    default: false
  }
})

const width = ref(window.innerWidth);
const husideRef = ref(null);
const ensideRef = ref(null);

const checkLang = () => {
  const lang = localStorage.getItem('locale') || 'hu';

  nextTick(() => {
    if (husideRef.value && ensideRef.value) {
      if (lang === 'hu') {
        husideRef.value.classList.add('choosed-lang');
        ensideRef.value.classList.remove('choosed-lang');
      } else {
        ensideRef.value.classList.add('choosed-lang');
        husideRef.value.classList.remove('choosed-lang');
      }
    }
  });
};

const changeLang = (lang) => {
  localStorage.setItem('locale', lang);

  nextTick(() => {
    if (husideRef.value && ensideRef.value) {
      if (lang === 'hu') {
        husideRef.value.classList.add('choosed-lang');
        ensideRef.value.classList.remove('choosed-lang');
      } else {
        ensideRef.value.classList.add('choosed-lang');
        husideRef.value.classList.remove('choosed-lang');
      }
    }
  });
};

const visible = ref(false);
watchEffect(() => {
  if (visible.value) checkLang();
});

addEventListener("resize", () => {
  width.value = window.innerWidth;
});

onresize = () => {
  if (width.value == 892) checkLang();
};


onMounted(() => {
  checkLang()
})

</script>


<style lang="css" scoped>
.navbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 100;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  color: #f5f5f5;
  z-index: 100;
  height: 80px;
}

.header .header-logo {
  height: 50px;
}

.routes {
  display: flex;
  justify-content: center;
  align-items: center;
}

.routes ul {
  display: flex;
  justify-content: center;
  align-items: center;
  list-style: none;
  gap: 40px;
  padding: 0;
  margin: auto;
  margin-right: 40px;
}

.routes ul li a {
  text-decoration: none;
  color: #FEF7F8;
  font-size: 16px;
  transition: font-weight 200ms ease-in-out;
}

.routes ul li a:hover {
  color: #FFDD00;
  transition: ease-in-out 200ms;
}


.routes ul li a.router-link-exact-active {
  font-weight: 500;
  color: #FFDD00;
}

.langs {
  display: flex;
  gap: 20px;
}

.lang {
  filter: brightness(0.5);
  cursor: pointer;
  margin: 0;
  height: 20px;
  width: 30px;
  transition: ease-in-out 200ms;
}

.lang:hover {
  filter: brightness(1.2);
  transition: ease-in-out 200ms;
}

.choosed-lang {
  filter: brightness(1);
}

.sidebar {
  display: none;
  cursor: pointer;
}

@media only screen and (max-width: 1400px) {
  .routes ul {
    gap: 60px;
  }

  .routes ul li a,
  .lang {
    font-size: 14px;
  }

  .header-icons a {
    width: 20px;
    height: 20px;
  }

  .header-icon {
    width: 20px;
    height: 20px;
  }

}

@media only screen and (max-width: 1240px) {
  .routes ul {
    gap: 40px;
  }

  .routes ul li a {
    font-size: 14px;
  }

  .header-icons {
    gap: 16px;
  }
}

@media only screen and (max-width: 1140px) {
  .routes ul {
    gap: 30px;
  }

  .routes ul li a {
    font-size: 12px;
  }

  .header-icons {
    gap: 14px;
  }

}

@media only screen and (max-width: 1050px) {

  .sidebar {
    display: block;
    height: 30px;
  }

  .routes,
  .header-icons,
  .header-icon,
  .lang {
    display: none;
  }

  .header .header-logo {
    height: 35px;
    margin-top: 10px;
  }
}
</style>